import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Col, Row } from 'reactstrap'

const CovidTestingInChicago = () => {
  return (
    <div id='website-responsive'>
    <div className='left-padding5rem1 right-padding5rem1 pb-md-5 '>
        <Row className='reverse-section pt-md-'>
            <Col md='12' lg='5' className='flex-center pb-md-0 pb-2'>
                <div className='flex-center pb-md-0 pb-4'>
                    <img className='img-w18' src='covid-testing/RT_PCR-Covid-Testing-img1-v1.webp' alt='Covid Services' height='auto' width='' />
                </div>
            </Col>
            <Col md='12' lg='7' className='ps-lg-0  m-en'>
                <div className='py-4'>
                    <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                        RT-PCR COVID-19 TEST IN CHICAGO
                    </div>
                    <hr className='hr-style my-md-1' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>

                    <div className='py-4'>
                        <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                        Nobody wants to go through the inconveniency of waiting in long queues to get tested. But, with United Lab Care, you can get RT PCR test without going through the lengthy appointment process. Moreover, there is no requirement for insurance because United Lab Care is a well-known and reputable provider of free RT-PCR Covid-19 test services in Chicago IL with a guarantee of rapid and accurate PCR Test results.
                        </div>
                    </div>

                    <div className='flex-center1'>
                    <Link to='/book-covid-test-appointment'>
                        <Button className='btn-ss-secondary rounded20 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                            <text className='text-montserrat fw-600 fs-ss-16' style={{ padding:'12px 14px',}}>
                                BOOK COVID TEST
                            </text>
                        </Button>
                    </Link>
                    </div>
                </div>
            </Col>
        </Row>
    </div>
</div>
  )
}

export default CovidTestingInChicago